<template>
  <div class="pwd-mask" v-if="visible" @click.self="$emit('cancel')">
    <div class="pwd-box">
      <h3 class="pwd-title">{{ title }}</h3>
      <input
        type="password"
        v-model="pwd"
        class="pwd-input"
        :placeholder="placeholder"
        @keyup.enter="confirm"
      />
      <template v-if="needConfirm">
        <input
          type="password"
          v-model="pwd2"
          class="pwd-input pwd-input-again"
          :placeholder="confirmPlaceholder"
          @keyup.enter="confirm"
        />
        <div v-if="err" class="pwd-err">{{ err }}</div>
      </template>
      <div class="pwd-actions">
        <button class="pwd-cancel" @click="$emit('cancel')">取消</button>
        <button class="pwd-ok" @click="confirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  name: 'ParentPwdModal',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '请输入家长密码' },
    placeholder: { type: String, default: '家长密码' },
    // 设置密码场景：需要第二遍确认输入，两次一致才允许提交
    needConfirm: { type: Boolean, default: false },
    confirmPlaceholder: { type: String, default: '再次输入家长密码' }
  },
  emits: ['confirm', 'cancel'],
  setup(props, { emit }) {
    const pwd = ref('');
    const pwd2 = ref('');
    const err = ref('');

    // 每次打开时清空上次输入与错误提示
    watch(() => props.visible, (v) => {
      if (v) {
        pwd.value = '';
        pwd2.value = '';
        err.value = '';
      }
    });

    const confirm = () => {
      if (!pwd.value) {
        err.value = '请输入密码';
        return;
      }
      if (props.needConfirm && pwd.value !== pwd2.value) {
        err.value = '两次输入的密码不一致';
        return;
      }
      err.value = '';
      emit('confirm', pwd.value);
      pwd.value = '';
      pwd2.value = '';
    };
    return { pwd, pwd2, err, confirm };
  }
};
</script>
<style scoped>
.pwd-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.pwd-box {
  width: 320px;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}
.pwd-title {
  margin: 0 0 18px;
  font-size: 17px;
  color: #1e293b;
  font-weight: 600;
}
.pwd-input {
  width: 100%;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
}
.pwd-input:focus {
  border-color: #ff9600;
}
.pwd-input-again {
  margin-top: 10px;
}
.pwd-err {
  margin-top: 8px;
  font-size: 12px;
  color: #e02020;
  text-align: left;
}
.pwd-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}
.pwd-cancel,
.pwd-ok {
  flex: 1;
  height: 40px;
  border-radius: 20px;
  border: none;
  font-size: 14px;
  cursor: pointer;
}
.pwd-cancel {
  background: #f1f5f9;
  color: #475569;
}
.pwd-ok {
  background: #ff9600;
  color: #fff;
}
</style>
